import React from 'react'

import { ShortAnswerInactiveProps } from './shortAnswerInactive.types'
import * as S from './../../fieldsInactive.styles'

export const ShortAnswerInactive = ({ item, ...props }: ShortAnswerInactiveProps) => {
    return (
        <S.FieldInactiveWrapper {...props}>
            <S.Header>
                <S.Title>{item.value}</S.Title>

                {item.required && <S.Required>*Required</S.Required>}
            </S.Header>

            <S.TextField>Short answer text</S.TextField>
        </S.FieldInactiveWrapper>
    )
}
